<template>
  <div
    class="counter-wrapper d-flex align-items-center justify-content-center text-min emphasis"
    :class="[positionX, positionY]"
  >
    {{ counter }}
  </div>
</template>

<script lang="ts" setup>
import { withDefaults, defineProps } from "vue";

type CounterIconProps = {
  counter: number;
  positionX: "left" | "center" | "right";
  positionY: "top" | "middle" | "bottom";
};

withDefaults(defineProps<CounterIconProps>(), {
  counter: 0,
  positionX: "right",
  positionY: "top",
});
</script>

<style scoped>
.counter-wrapper {
  position: absolute;
  background-color: #82ab72;
  border-radius: 50px;
  color: white;
  width: 18px;
  height: 18px;
}

.right {
  right: 0;
}

.top {
  top: 0;
}

.middle {
  top: 25%;
}

.bottom {
  bottom: 0;
}
</style>
